import type { Step } from "react-joyride";

export const leaveTypeDetailTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຫນ້າລາຍລະອຽດປະເພດລາ. ເບິ່ງຂໍ້ມູນປະເພດລາ ກັບຄືນ ຫຼື ແກ້ໄຂ. ກົດ 'ທົດລອງທົດສອບ' ເພື່ອເລີ່ມທົດສອບການນຳທາງ.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="leave-type-detail-back"]',
    content: "ກັບຄືນສູ່ລາຍການປະເພດລາ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="leave-type-detail-form"]',
    content: "ລາຍລະອຽດປະເພດລາ. ກົດແກ້ໄຂເພື່ອແກ້ໄຂ.",
    placement: "top",
  },
];
